import { RouterProvider } from "react-router-dom";
import "./App.css";
import router from "./routers/Routes";
import { Provider } from "react-redux";
import { store } from "./Redux/store";

const App = () => {
  return (
    <>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </>
  );
};

export default App;
